import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import Modal from '../../../common/modal/Modal';
import MaintenanceChecklistBasicActivityForm from './MaintenanceChecklistBasicActivityForm';

import {
  getMaintenanceChecklist,
  putMaintenanceChecklistBasicActivities,
} from '../../../../actions';
import { tzNormalizeDate } from '../../../../utils/date';

const toArray = (value) => {
  if (!value) return [];

  return Array.isArray(value) ? value : [value];
};

const normalizeDate = (value) =>
  value
    ? tzNormalizeDate({
        date: value,
      })
    : null;

const getId = (value) => {
  if (!value) return null;

  if (typeof value === 'number' || typeof value === 'string') {
    return value;
  }

  return value.value || value.employeeId || value.id || null;
};

const getEmployeeId = (employee) => {
  if (!employee) return null;

  if (typeof employee === 'number' || typeof employee === 'string') {
    return employee;
  }

  if (employee.employeeId) {
    return getId(employee.employeeId);
  }

  if (employee.employee) {
    return getId(employee.employee);
  }

  if (employee.mechanic) {
    return getId(employee.mechanic);
  }

  return getId(employee);
};

const buildMechanicList = (item) => {
  const mechanics = toArray(
    item.mechanics || item.maintenancePlanningActivityExecutionEmployeeList,
  );

  return mechanics
    .map((employee) => ({
      employeeId: getEmployeeId(employee),
    }))
    .filter((employee) => employee.employeeId);
};

const normalizeBasicActivityExecutionList = (list) =>
  toArray(list).map((item) => ({
    ...item,

    activityId: getId(item.activityId),

    maintenanceFailModeId: getId(item.maintenanceFailModeId),

    maintenanceBasicActivityId: getId(item.maintenanceBasicActivityId),

    startDate: normalizeDate(item.startDate),

    endDate: normalizeDate(item.endDate),

    comment: item.comment || item.observations || '',

    maintenancePlanningActivityExecutionEmployeeList: buildMechanicList(item),
  }));
const MaintenanceChecklistBasicActivityButton = ({
  maintenanceChecklist,
  dispatchPutMaintenanceChecklistBasicActivities,
  dispatchGetMaintenanceChecklist,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const closeModal = () => {
    setShowModal(false);
    setModalBody(null);
  };

  const onModalSubmit = async (
    maintenanceChecklistBasicActivityExecutionList,
  ) => {
    const mappedBasicActivities = normalizeBasicActivityExecutionList(
      maintenanceChecklistBasicActivityExecutionList,
    );

    const response = await dispatchPutMaintenanceChecklistBasicActivities({
      maintenanceChecklistId: maintenanceChecklist.id,
      maintenanceChecklistBasicActivityExecutionList: mappedBasicActivities,
    });

    if (response) {
      dispatchGetMaintenanceChecklist({
        maintenanceChecklistId: maintenanceChecklist.id,
      });

      closeModal();
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const buildModalBody = () => {
    setModalBody(
      <MaintenanceChecklistBasicActivityForm
        onSubmit={onModalSubmit}
        showFooter
      />,
    );
  };

  useEffect(() => {
    if (showModal) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Registrar Checklist Básico"
        body={modalBody}
        size="xl"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />

      <Button
        color="success"
        onClick={openModal}
        disabled={disabled || !maintenanceChecklist || !maintenanceChecklist.id}
      >
        <i className="fa fa-check-square-o" /> Registrar Checklist Básico
      </Button>
    </>
  );
};

MaintenanceChecklistBasicActivityButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  maintenanceChecklist: PropTypes.object.isRequired,
  dispatchPutMaintenanceChecklistBasicActivities: PropTypes.func.isRequired,
  dispatchGetMaintenanceChecklist: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

MaintenanceChecklistBasicActivityButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchPutMaintenanceChecklistBasicActivities:
    putMaintenanceChecklistBasicActivities,
  dispatchGetMaintenanceChecklist: getMaintenanceChecklist,
};

export default connect(
  null,
  mapDispatchToProps,
)(MaintenanceChecklistBasicActivityButton);
